import { Pane, Text } from 'evergreen-ui'
import {
  isMixedInterviewRound,
  majorNeedsInterview,
  resolveNoInterviewText,
  resolveRoundFlag,
  useStatusContent,
} from '../../../config/roundContent'

const StatusRegister_1 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { content, statusContent } = useStatusContent(row.ROB_ID, "1")
  const majorId = row.Major1_MAJOR_ID || row.Major_MAJOR_ID

  const banner = (text, extra) => (
    <Pane
      color="#fff"
      backgroundColor="#008616ff"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={14}
      margin={0}
      fontWeight={700}
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
    >
      {text}
      {extra ? <Text color="#fff" fontSize={12} marginTop={4}>{extra}</Text> : null}
    </Pane>
  )

  const title = statusContent.titleText || 'มีสิทธิ์เข้ารับการสอบสัมภาษณ์'
  const body = statusContent.bodyText || ''
  const noInterviewText = resolveNoInterviewText(content, statusContent)

  if (row.REGISTER_TYPE_ID === "1" || row.REGISTER_TYPE_ID === "5") {
    if (isMixedInterviewRound(content, row.ROB_ID)) {
      return majorNeedsInterview(content, row.ROB_ID, majorId)
        ? banner(title, body)
        : banner(noInterviewText || body || title)
    }
    if (resolveRoundFlag(content, "statusInterviewEligible", row.ROB_ID)) {
      return banner(title, body)
    }
    if (statusContent.titleText || statusContent.bodyText) {
      return banner(title, body)
    }
    return null
  }

  return banner(title, body)
}

export default StatusRegister_1
